import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/sportsData';

const categoryImages: Record<string, string> = {
  football: 'https://readdy.ai/api/search-image?query=Professional%20football%20soccer%20player%20kicking%20ball%20on%20green%20grass%20field%20under%20stadium%20lights%2C%20dramatic%20sports%20action%20with%20motion%20blur%2C%20clean%20dark%20background%20with%20soft%20ambient%20light%2C%20sports%20journalism%20photography%20style%20with%20vibrant%20energy&width=600&height=400&seq=cat-football&orientation=landscape',
  basketball: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20player%20dunking%20dramatically%20on%20court%2C%20indoor%20arena%20with%20spotlight%20effect%2C%20athletic%20form%20captured%20mid-air%2C%20clean%20minimal%20background%20with%20warm%20toned%20lighting%2C%20sports%20photography%20aesthetic&width=600&height=400&seq=cat-basketball&orientation=landscape',
  tennis: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20player%20serving%20ball%20on%20clay%20court%2C%20athletic%20pose%20captured%20at%20peak%20moment%2C%20clean%20orange%20court%20surface%20with%20soft%20natural%20lighting%2C%20sports%20photography%20style%20with%20dynamic%20composition&width=600&height=400&seq=cat-tennis&orientation=landscape',
  esports: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20gaming%20arena%20with%20colorful%20LED%20lighting%2C%20professional%20gaming%20setup%20with%20mechanical%20keyboard%20and%20mouse%2C%20dark%20ambient%20atmosphere%20with%20neon%20accents%2C%20cyberpunk%20aesthetic%20with%20clean%20composition&width=600&height=400&seq=cat-esports&orientation=landscape',
  baseball: 'https://readdy.ai/api/search-image?query=Professional%20baseball%20batter%20swinging%20bat%20on%20field%2C%20golden%20sunset%20lighting%20illuminating%20stadium%2C%20dynamic%20action%20photography%20capturing%20motion%2C%20clean%20green%20field%20background%20with%20warm%20atmosphere&width=600&height=400&seq=cat-baseball&orientation=landscape',
  racing: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20in%20motion%20on%20racetrack%2C%20speed%20blur%20effect%20with%20dramatic%20perspective%2C%20dark%20asphalt%20surface%20with%20tire%20marks%2C%20professional%20motorsport%20photography%20with%20aggressive%20styling&width=600&height=400&seq=cat-racing&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            热门赛事分类
          </h2>
          <p className="text-sm text-foreground-600">选择您感兴趣的体育项目，获取专业赛事数据与分析</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {sportCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer transform hover:-translate-y-1"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={categoryImages[cat.slug] || ''}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${cat.icon} text-xl text-background-50`}></i>
                    </div>
                    <span className="font-heading text-lg font-semibold text-background-50">{cat.name}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">{cat.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    <i className="ri-live-line mr-1"></i>{cat.matchCount}场赛事
                  </span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
                    进入 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}